import script from "./SeniorCitizenDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SeniorCitizenDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SeniorCitizenDashboard.vue?vue&type=style&index=0&id=2e91403d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e91403d"]])

export default __exports__